// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page__container[data-v-6d7d9476]{margin:88px 0}@media(max-width:575.98px){.page__container[data-v-6d7d9476]{margin-top:1px;margin-bottom:48px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
